import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchBarService {
  private _selectedPointOfInterestId: { id: number | null, isStory: boolean } = {id: null, isStory: false};
  selectedPointOfInterestId$ = new BehaviorSubject<{ id: number | null, isStory: boolean }>({id: null, isStory: false});
  constructor() { }

  setSelectedPointOfInterestId(id: number | null, isStory = false) {
    if (id === this._selectedPointOfInterestId.id) {
      return;
    }
    this._selectedPointOfInterestId = {id, isStory};
    this.selectedPointOfInterestId$.next({id, isStory});
  }
}
